/* eslint-disable react/no-unused-state */
import React from 'react'
import {
  IAddress,
  IAddressFormViewNavParams,
  IApiOptions,
  IPackageBillingCycle,
  IProfile,
  IProfileMap,
  IQuickAddress,
  IResponseGetSubscriptionsOrder,
  ISelectedStoreMap,
  ISubscriptionPackageList,
  IXSellyFile,
  SubscriptionPackageListItems,
} from 'x/index'
import * as util from 'x/utils/util'
import _ from 'lodash'
import dayjs from 'dayjs'
import * as NavActions from 'x/utils/navigation'
import * as upload from 'x/utils/upload'
import api from 'x/utils/api'
import p from 'x/config/platform-specific'
import CONS from 'x/config/constants'

export interface ISelectedAddOn {
  sku: string
  billing_cycle: number
  qty: number
}

interface IBasePaymentSubscriptionViewProps {
  profile: IProfileMap
  selectedStore: ISelectedStoreMap
  subscription: any
  myStores: any
  fetchSubscription: any
}

interface IBasePaymentSubscriptionViewState {
  subscriptionPackageList: ISubscriptionPackageList
  profile: IProfile
  isLoading: boolean

  selectedOptionRangePackageIndex: number // รายบละเอียด package list จาก หลังบ้าน
  selectedMainPackage: SubscriptionPackageListItems // แพ็กหลักที่เลือก
  addOnPackages: ISelectedAddOn[] // แพ็กเสริมที่เลือก

  uploadedUrl: string
  paymentPostDate: Date

  pendingOrderData: IResponseGetSubscriptionsOrder

  mode: 'upgrade' | 'buy_package' | 'add_on' | 'continue_package' | 'pending'

  currentPackageBillingCycle: IPackageBillingCycle[]
  nextPackageBillingCycle: IPackageBillingCycle[]

  isvisibleChangeBillingCycle: boolean

  orderCountHistory: { start_date: string; end_date: string; order_count: number }[]

  isOrderCountHistory: boolean

  subscriptionAddressContact: IAddress
  isTaxReceiptRequested: boolean
  isTaxWithheld: boolean

  selectedPaymentChannelIndex: number

  qrCodeObject: {
    order_id: string
    amount: number
    qr_image: string
    expiry_date: string
  }
}

export default abstract class BasePaymentSubscriptionView extends React.Component<
  IBasePaymentSubscriptionViewProps,
  IBasePaymentSubscriptionViewState
> {
  inLoopPamyntChackProcess: boolean

  // eslint-disable-next-line react/no-unused-class-component-methods
  // @ts-ignore
  carouselRef: React.useRef<any>

  PACKAGE_SKU_CYCLE_1: string[]

  PACKAGE_SKU_CYCLE_12: string[]

  ADD_ON_COUNTSTANT: {
    title: string
    addOnKey: string
    cutSku: string
  }[]

  SELECTED_PAYMENT_CHANNELS_INDEX: {
    index: number
    label: string
    prefixIcon: { name: string; family: string; size: string }
  }[]

  constructor(props) {
    super(props)
    this.state = {
      subscriptionPackageList: null,
      profile: null,
      selectedOptionRangePackageIndex: 3,
      selectedMainPackage: null,
      addOnPackages: null,
      uploadedUrl: null,
      paymentPostDate: new Date(),
      pendingOrderData: null,
      isLoading: true,
      mode: 'buy_package',
      currentPackageBillingCycle: null,
      nextPackageBillingCycle: null,
      isvisibleChangeBillingCycle: false,
      orderCountHistory: null,
      isOrderCountHistory: false,
      subscriptionAddressContact: null,
      isTaxReceiptRequested: false,
      isTaxWithheld: false,

      selectedPaymentChannelIndex: 0,
      qrCodeObject: null,
    }

    this.inLoopPamyntChackProcess = false

    this.ADD_ON_COUNTSTANT = [
      {
        title: 'ออเดอร์',
        addOnKey: 'order_count_quota',
        cutSku: 'ADDON-QUOTA-ORDER',
      },
      {
        title: 'ช่องทางขาย',
        addOnKey: 'mkp_quota',
        cutSku: 'ADDON-QUOTA-MKP',
      },
      {
        title: 'กลุ่มสมาชิก',
        addOnKey: 'ug_quota',
        cutSku: 'ADDON-QUOTA-UG',
      },
      {
        title: 'รายการราคา',
        addOnKey: 'pg_quota',
        cutSku: 'ADDON-QUOTA-PG',
      },
      {
        title: 'ผู้ช่วย',
        addOnKey: 'helper_count',
        cutSku: 'ADDON-QUOTA-HELPER',
      },
      {
        title: 'ร้านค้า',
        addOnKey: 'store_count',
        cutSku: 'ADDON-QUOTA-STORE',
      },
      // {
      //   title: 'คลัง',
      //   addOnKey: 'wh_quota',
      //   cutSku: 'ADDON-QUOTA-WH',
      // },
    ]

    this.SELECTED_PAYMENT_CHANNELS_INDEX = [
      {
        index: 0,
        label: 'สแกน QR Code',
        prefixIcon: { name: 'qrcode-scan', family: 'MaterialCommunityIcons', size: 'xs' },
      },
      {
        index: 1,
        label: 'โอนชำระ',
        prefixIcon: { name: 'bank-transfer', family: 'MaterialCommunityIcons', size: 'sm' },
      },
    ]
  }

  async componentDidMount() {
    // console.log('BasePaymentSubscriptionView componentDidMount => ', this.props.subscription.toJS())
    await this._setProfile()
    await this._setCurrentAndNextPackageBillingCycle()
    await this._getInitData()
    await this._getSubscriptionOrder()
    // await this._getSubscriptionAddress()
  }

  _setCurrentAndNextPackageBillingCycle = async () => {
    const { subscription } = this.props
    if (_.isNil(subscription)) {
      return null
    }
    const currentPackageBillingCycle = subscription.has('current_package_billing_cycle')
      ? subscription.get('current_package_billing_cycle').toJS()
      : null
    const nextPackageBillingCycle = subscription.has('next_package_billing_cycle')
      ? subscription.get('next_package_billing_cycle').toJS()
      : null
    await util.setStatePromise(this, { currentPackageBillingCycle, nextPackageBillingCycle })
  }

  _setLoading = () => {
    this.setState({ isLoading: true })
  }

  _unSetLoading = () => {
    this.setState({ isLoading: false })
  }

  _getInitData = async () => {
    // @ts-ignore
    const params = util.getNavParams(this.props)
    const { subscriptionPackageList, mode, pendingOrder } = params
    const { items } = pendingOrder
    let mainPackage = null
    const mainPackageSku = items.find((item) => _.includes(CONS.SUBSCRIPTION_MAIN_PACKAGE_SKU, item.sku))
    if (!_.isNil(mainPackageSku)) {
      mainPackage = subscriptionPackageList.items.find((item) => item.sku === mainPackageSku.sku)
    }
    await util.setStatePromise(this, {
      selectedMainPackage: mainPackage,
      subscriptionPackageList,
      mode: _.isNil(mode) ? 'buy_package' : mode,
      pendingOrderData: pendingOrder,
    })
    this._unSetLoading()
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  goBack = () => {
    // @ts-ignore
    const { navigation } = this.props
    const { pendingOrderData, mode } = this.state
    const params = this._getParams()
    const { succeedPaymentCallBack } = params
    if (_.isFunction(succeedPaymentCallBack) && !_.isNil(pendingOrderData)) {
      succeedPaymentCallBack('pending')
      // @ts-ignore
      util.navGoBack(this.props)
      return
    }
    if (mode === 'continue_package') {
      navigation.pop(2)
      // @ts-ignore
      util.navGoBack(this.props)
      return
    }
    // @ts-ignore
    util.navGoBack(this.props)
  }

  _callbackSucceedChangeContinuePackage = async (sku: string) => {
    const { subscriptionPackageList } = this.state
    const selectedMainPackage = subscriptionPackageList.items.find((item) => item.sku === sku)
    await util.setStatePromise(this, {
      selectedMainPackage,
    })
  }

  _onClickChangeContinuePackage = () => {
    const { selectedMainPackage } = this.state
    // @ts-ignore
    // util.navGoBack(this.props)
    const mode = 'continue_package'
    // @ts-ignore
    const { navigation } = this.props
    const { subscriptionPackageList } = this.state
    navigation.dispatch(
      NavActions.navToInAppPurchaseView({
        subscriptionPackageList,
        mode,
        callBackSucceedPaymentIos: () => null,
        succeedPaymentCallBack: () => null,
        callbackSucceedChangeContinuePackage: (sku: string) => this._callbackSucceedChangeContinuePackage(sku),
        sku: selectedMainPackage.sku,
      })
    )
  }

  _setProfile = async (): Promise<void> => {
    const { profile } = this.props
    const profileJS = profile?.toJS() || null
    await util.setStatePromise(this, {
      profile: profileJS,
    })
  }

  // _getAddOnDataByCutSku = (cutSku: string) => {
  //   const { subscriptionPackageList, addOnPackages } = this.state
  //   if (_.isNil(addOnPackages)) {
  //     return null
  //   }

  //   let fullSku = null
  //   addOnPackages.forEach((addOn) => {
  //     const { sku } = addOn
  //     const isPrefix = sku.startsWith(cutSku)
  //     if (isPrefix) {
  //       fullSku = sku
  //     }
  //   })

  //   if (_.isNil(fullSku)) {
  //     return null
  //   }

  //   const { items } = subscriptionPackageList
  //   let jsonData = null
  //   items.forEach((item) => {
  //     const { sku } = item
  //     if (sku === fullSku) {
  //       jsonData = item
  //     }
  //   })
  //   return jsonData
  // }

  _getSelectedAddOnDataByCutSku = (cutSku: string) => {
    const { subscriptionPackageList, addOnPackages } = this.state

    // If addOnPackages is null or undefined, return null.
    if (_.isNil(addOnPackages)) {
      return null
    }

    // Use the find method to locate the first add-on package whose SKU starts with cutSku.
    const fullSku = addOnPackages.find((addOn) => addOn.sku.startsWith(cutSku))?.sku

    // If no matching SKU is found, return null.
    if (_.isNil(fullSku)) {
      return null
    }

    // Use the find method to locate the item in subscriptionPackageList with the matching SKU.
    const jsonData = subscriptionPackageList.items.find((item) => item.sku === fullSku) || null

    return jsonData
  }

  // This function retrieves the selected add-on package based on the provided cutSku.
  _getAddOnSelectedData = (cutSku: string) => {
    const { addOnPackages } = this.state

    // If addOnPackages is null or undefined, return null.
    if (_.isNil(addOnPackages)) {
      return null
    }

    // Use the find method to locate the first add-on package whose SKU starts with cutSku.
    // If no matching add-on is found, return null.
    return addOnPackages.find((addOn) => addOn.sku.startsWith(cutSku)) || null
  }

  _getAddOnSelectedDataBySku = (sku: string) => {
    const { subscriptionPackageList } = this.state
    return subscriptionPackageList.items.find((item) => item.sku === sku) || null
  }

  _getStartAndEndBillingCycle = (billingCycle: number) => {
    const { subscriptionPackageList } = this.state
    // console.log('subscriptionPackageList => ', subscriptionPackageList)
    const { future_billing_dates, current_billing_dates } = subscriptionPackageList
    let startBillingDate = current_billing_dates
    // ถ้าแพ็กฟรีมาเลยจะไม่มี current_billing_dates
    if (_.isNil(current_billing_dates) || current_billing_dates.length === 0) {
      startBillingDate = future_billing_dates
    }
    const { start } = startBillingDate[0]
    const { end } = future_billing_dates[billingCycle - 1]
    return `${dayjs(start, 'YYYY-MM-DD').format('D MMM YYYY')} - ${dayjs(end, 'YYYY-MM-DD').format('D MMM YYYY')}`
  }

  _getCurrentSelectedAddOnDataByCutSku = (cutSku: string) => {
    const { subscriptionPackageList, currentPackageBillingCycle } = this.state

    // If addOnPackages is null or undefined, return null.
    if (_.isNil(currentPackageBillingCycle)) {
      return null
    }

    // Use the find method to locate the first add-on package whose SKU starts with cutSku.
    const fullSku = currentPackageBillingCycle.find((addOn) => addOn.sku.startsWith(cutSku))?.sku

    // If no matching SKU is found, return null.
    if (_.isNil(fullSku)) {
      return null
    }

    // Use the find method to locate the item in subscriptionPackageList with the matching SKU.
    const jsonData = subscriptionPackageList.items.find((item) => item.sku === fullSku) || null

    return jsonData
  }

  _callBackFormSelectedAddOn = async (addOnSelectedList: ISelectedAddOn[], cutSku: string) => {
    // console.log('addOnSelectedList => ', addOnSelectedList)
    // console.log('cutSku => ', cutSku)
    const { addOnPackages } = this.state
    if (_.isNil(addOnPackages) || addOnPackages.length === 0) {
      // this.setState({ addOnPackages: addOnSelectedList })
      await util.setStatePromise(this, {
        addOnPackages: addOnSelectedList,
      })
    } else if (_.isNil(addOnSelectedList) || addOnSelectedList.length === 0) {
      const newAddOnPackages = addOnPackages.filter((addOn) => !addOn.sku.startsWith(cutSku))
      // this.setState({ addOnPackages: newAddOnPackages })
      await util.setStatePromise(this, {
        addOnPackages: newAddOnPackages,
      })
    } else {
      const oldAddOnPackages = _.cloneDeep(addOnPackages)
      // console.log('oldAddOnPackages => ', oldAddOnPackages)
      const newAddOnPackages = oldAddOnPackages.filter((addOn) => !addOn.sku.startsWith(cutSku))
      // console.log('newAddOnPackages => ', newAddOnPackages)
      addOnSelectedList.forEach((addOnSelected) => {
        newAddOnPackages.push(addOnSelected)
      })

      await util.setStatePromise(this, {
        addOnPackages: newAddOnPackages,
      })
    }
  }

  // SUBSCRIPTION_UPGRADE_PACKAGE_SKU: [
  //   'BRONZE-TO-SILVER-CYCLE-1',
  //   'BRONZE-TO-GOLD-CYCLE-1',
  //   'BRONZE-TO-PLATINUM-CYCLE-1',

  //   'SILVER-TO-GOLD-CYCLE-1',
  //   'SILVER-TO-PLATINUM-CYCLE-1',

  //   'GOLD-TO-PLATINUM-CYCLE-1',
  // ]

  _getMainPackageByUpgradePackageMode = () => {
    const { selectedMainPackage, subscriptionPackageList } = this.state
    const { sku } = selectedMainPackage
    let shortMainSku = 'PACKAGE-SILVER-CYCLE'
    if (sku.match(/TO-GOLD/)) {
      shortMainSku = 'PACKAGE-GOLD-CYCLE'
    }
    if (sku.match(/TO-PLATINUM/)) {
      shortMainSku = 'PACKAGE-PLATINUM-CYCLE'
    }
    const { items } = subscriptionPackageList
    let selectedAddOn = null
    items.forEach((item) => {
      if (item.sku.includes(shortMainSku)) {
        selectedAddOn = item
      }
    })
    selectedAddOn.billing_cycle = selectedMainPackage.billing_cycle
    return selectedAddOn
  }

  _getSelectedAddOn = (sku: string) => {
    if (_.isNil(sku)) {
      return null
    }
    const { subscriptionPackageList } = this.state
    const { items } = subscriptionPackageList
    let selectedAddOn = null
    items.forEach((item) => {
      if (item.sku === sku) {
        selectedAddOn = item
      }
    })
    return selectedAddOn
  }

  _getAddOnSelectedListData = (cutSku: string) => {
    const { addOnPackages } = this.state

    if (_.isNil(addOnPackages)) {
      return null
    }

    const listAddOn = []
    // addOnPackages.find((addOn) => addOn.sku.startsWith(cutSku)) || null
    addOnPackages.forEach((addOn) => {
      const { sku } = addOn
      const isPrefix = sku.startsWith(cutSku)
      if (isPrefix) {
        listAddOn.push(addOn)
      }
    })
    return listAddOn
  }

  _getAddOnCount = (addOn: { title: string; addOnKey: string; cutSku: string }) => {
    const { addOnPackages } = this.state
    let countAddOn = 0
    if (_.isNil(addOnPackages)) {
      return countAddOn
    }
    const addOnFromCutSku = this._getAddOnSelectedListData(addOn.cutSku)
    addOnFromCutSku.forEach((addOnSelected) => {
      const getAddOn = this._getAddOnSelectedDataBySku(addOnSelected.sku)
      const countQty = getAddOn.data_json[addOn.addOnKey] * addOnSelected.qty
      countAddOn += countQty
    })
    return countAddOn
  }

  _onSubmitUpload = async () => {
    this._setLoading()
    // @ts-ignore มันคือ IXSellyFile แต่ไม่ได้ประกาศใน state
    const { selectedFile, paymentPostDate } = this.state
    // console.log('_onTestUploadPress selectedFile', selectedFile)

    if (_.isNil(selectedFile)) {
      p.op.showConfirmationOkOnly('', 'กรุณาเลือกไฟล์ที่ต้องการอัพโหลด')
      this._unSetLoading()
      return
    }

    const YYMM = dayjs(paymentPostDate).format('YYMM')
    const YYMMDD = dayjs(paymentPostDate).format('YYMMDD')
    const HHMMSS = dayjs(paymentPostDate).format('HHmmss')
    const fileName = `subs_payment_slip_${YYMMDD}_${HHMMSS}`
    const path = `subs/payment_slip/${YYMM}`
    try {
      // console.log('_onTestUploadPress file', selectedFile)
      const uploadResponse = await upload.uploadFile(selectedFile as IXSellyFile, { fileName, folderPath: path })
      // console.log('_onTestUploadPress uploadResponse', uploadResponse)
      // @ts-ignore
      await util.setStatePromise(this, { uploadedUrl: uploadResponse.url })
      await this._onSubmitPayment()
    } catch (error) {
      // console.log('_onTestUploadPress error', error)
      // p.op.showConfirmationOkOnly('', `เกิดข้อผิดพลาด ${error}`)
      await util.setStatePromise(this, { uploadedUrl: null })
      this._unSetLoading()
    }
  }

  // _onSubmitUploadDayAddOne = async () => {
  //   this._setLoading()
  //   // @ts-ignore มันคือ IXSellyFile แต่ไม่ได้ประกาศใน state
  //   const { selectedFile, paymentPostDate } = this.state
  //   // console.log('_onTestUploadPress selectedFile', selectedFile)

  //   if (_.isNil(selectedFile)) {
  //     p.op.showConfirmationOkOnly('', 'กรุณาเลือกไฟล์ที่ต้องการอัพโหลด')
  //     this._unSetLoading()
  //     return
  //   }

  //   const YYMM = dayjs(paymentPostDate).format('YYMM')
  //   const YYMMDD = dayjs(paymentPostDate).format('YYMMDD')
  //   const HHMMSS = dayjs(paymentPostDate).format('HHmmss')
  //   const fileName = `/subs_payment_slip_${YYMMDD}_${HHMMSS}`
  //   const path = `subs/payment_slip/${YYMM}/${YYMMDD}_${HHMMSS}`
  //   try {
  //     // console.log('_onTestUploadPress file', selectedFile)
  //     const uploadResponse = await upload.uploadFile(selectedFile as IXSellyFile, { fileName, folderPath: path })
  //     // console.log('_onTestUploadPress uploadResponse', uploadResponse)
  //     // @ts-ignore
  //     await util.setStatePromise(this, { uploadedUrl: uploadResponse.url })
  //     await this._onSubmitPaymentDayAddOne()
  //   } catch (error) {
  //     // console.log('_onTestUploadPress error', error)
  //     // p.op.showConfirmationOkOnly('', `เกิดข้อผิดพลาด ${error}`)
  //     await util.setStatePromise(this, { uploadedUrl: null })
  //     this._unSetLoading()
  //   }
  // }

  _getSumTotalPayment = () => {
    const { selectedMainPackage, addOnPackages, mode } = this.state
    if (_.isNil(selectedMainPackage)) {
      return 0
    }

    const { price_with_vat } = selectedMainPackage
    let price = 0
    if (mode !== 'add_on') {
      price += price_with_vat
    }
    if (!_.isNil(addOnPackages)) {
      addOnPackages.forEach((addOn) => {
        const { billing_cycle, qty, sku } = addOn
        const selectedPackage = this._getAddOnSelectedDataBySku(sku)
        price += selectedPackage.price_with_vat * qty * billing_cycle
      })
    }
    return price
  }

  _getSumTotalPriceBeforeVat = () => {
    const { selectedMainPackage, addOnPackages, mode } = this.state
    if (_.isNil(selectedMainPackage)) {
      return 0
    }

    const { price_before_vat } = selectedMainPackage
    let price = 0
    if (mode !== 'add_on') {
      price += price_before_vat
    }
    if (!_.isNil(addOnPackages)) {
      addOnPackages.forEach((addOn) => {
        const { billing_cycle, qty, sku } = addOn
        const selectedPackage = this._getAddOnSelectedDataBySku(sku)
        price += selectedPackage.price_before_vat * qty * billing_cycle
      })
    }
    return price
  }

  _getSumTotalVat = () => {
    const { selectedMainPackage, addOnPackages, mode } = this.state
    if (_.isNil(selectedMainPackage)) {
      return 0
    }

    const { vat } = selectedMainPackage
    let price = 0
    if (mode !== 'add_on') {
      price += vat
    }
    if (!_.isNil(addOnPackages)) {
      addOnPackages.forEach((addOn) => {
        const { billing_cycle, qty, sku } = addOn
        const selectedPackage = this._getAddOnSelectedDataBySku(sku)
        price += selectedPackage.vat * qty * billing_cycle
      })
    }
    return price
  }

  _getSumTotalWhTex = () => {
    const { selectedMainPackage, addOnPackages, mode } = this.state
    if (_.isNil(selectedMainPackage)) {
      return 0
    }

    const { wh_tax } = selectedMainPackage
    let price = 0
    if (mode !== 'add_on') {
      price += wh_tax
    }
    if (!_.isNil(addOnPackages)) {
      addOnPackages.forEach((addOn) => {
        const { billing_cycle, qty, sku } = addOn
        const selectedPackage = this._getAddOnSelectedDataBySku(sku)
        price += selectedPackage.wh_tax * qty * billing_cycle
      })
    }
    return price
  }

  // _showWithheld = () => {
  //   const { resultPayment } = this.state
  //   if (_.isNil(resultPayment)) {
  //     return false
  //   }
  //   const { wh_tax_amount } = resultPayment
  //   // const price = this._getSumTotalPayment()
  //   return !_.isNil(wh_tax_amount) && wh_tax_amount > 0
  //   // const price = this._getSumTotalPayment()
  //   // return price >= 1000
  // }

  _onChangePaymentPostDate = (newDate: Date) => {
    this.setState({ paymentPostDate: newDate })
  }

  _getParams = () => {
    // @ts-ignore
    const params = util.getNavParams(this.props)
    return params
  }

  _onChangeBillingCycle = async (month: number) => {
    const { selectedMainPackage, subscriptionPackageList, addOnPackages } = this.state
    const mainPackageSku = selectedMainPackage.sku
    const cleanedSku = mainPackageSku.replace(/\d+/g, '') // Remove numbers from sku
    const sku = cleanedSku + month
    let selectedNewMainPackage = null
    const { items } = subscriptionPackageList
    if (!_.isNil(items)) {
      items.forEach((item) => {
        if (item.sku === sku) {
          selectedNewMainPackage = item
        }
      })
    }
    const newAddOnPackages = []
    if (!_.isNil(addOnPackages) && addOnPackages.length > 0) {
      addOnPackages.forEach((addOn) => {
        const newAddon: ISelectedAddOn = { sku: '', billing_cycle: 0, qty: 0 }
        newAddon.sku = addOn.sku
        newAddon.qty = addOn.qty
        newAddon.billing_cycle = month
        newAddOnPackages.push(newAddon)
      })
    }
    // this.setState({ selectedMainPackage: selectedNewMainPackage, addOnPackages: newAddOnPackages })
    await util.setStatePromise(this, {
      selectedMainPackage: selectedNewMainPackage,
      addOnPackages: newAddOnPackages,
    })
  }

  _getDifferenceFromMainPackageAndNowPackage = (key: string) => {
    const { subscription } = this.props
    const { selectedMainPackage, mode } = this.state
    const { data_json } = selectedMainPackage
    let newDataJsonMainPackage = _.cloneDeep(data_json)
    if (mode === 'upgrade') {
      // upgrade mode ต้องไปแปลง item_subtype ก่อน เพื่อนนำ item_subtype ไปคำนวณแสดงผลแพ็กเกจให้ถูกต้อง
      const newSelectedMainPackage = this._getMainPackageByUpgradePackageMode()
      newDataJsonMainPackage = _.cloneDeep(newSelectedMainPackage.data_json)
    }
    const value = !_.isNil(newDataJsonMainPackage) ? newDataJsonMainPackage[key] : 0
    const orderCountQuota = subscription.get(key)
    return orderCountQuota - value
  }

  _getSumAddonCurrentPackageBillingCycle = (cutSku: string, addonKey: string) => {
    const { currentPackageBillingCycle } = this.state
    if (_.isNil(currentPackageBillingCycle) || currentPackageBillingCycle.length === 0) {
      return 0
    }
    let sumTatal = 0
    currentPackageBillingCycle.forEach((item) => {
      if (item.sku.startsWith(cutSku)) {
        const { data_json, qty } = item
        if (!_.isNil(data_json)) {
          sumTatal += data_json[addonKey] * qty
        }
      }
    })
    return sumTatal
  }

  _getAddonCurrentPackageBillingCycle = (cutSku: string) => {
    const { currentPackageBillingCycle } = this.state
    if (_.isNil(currentPackageBillingCycle) || currentPackageBillingCycle.length === 0) {
      return null
    }
    const sumTatal = []
    currentPackageBillingCycle.forEach((item) => {
      if (item.sku.startsWith(cutSku)) {
        sumTatal.push(item)
      }
    })
    return sumTatal
  }

  _getMainPackageStarDateEndDateText = () => {
    const { currentPackageBillingCycle } = this.state
    // console.log('currentPackageBillingCycle => ', currentPackageBillingCycle)
    const endDate = () => {
      const { subscription } = this.props
      const endPackage = dayjs(subscription.get('m_e_date'), 'YYYY-MM-DD').clone().format('D MMM YYYY')
      return `ถึง ${endPackage}`
    }
    if (_.isNil(currentPackageBillingCycle)) {
      return endDate()
    }
    let mainPackage = null
    currentPackageBillingCycle.forEach((item) => {
      if (item.item_type === 'package_main') {
        mainPackage = item
      }
    })
    if (_.isNil(mainPackage)) {
      return endDate()
    }
    const { start_date, end_date } = mainPackage
    const startPackage = dayjs(start_date, 'YYYY-MM-DD').clone().format('D MMM YYYY')
    const endDataPackage = dayjs(end_date, 'YYYY-MM-DD').clone().format('D MMM YYYY')
    return `${startPackage} - ${endDataPackage}`
  }

  _onSaveQuickAddress = async (newAddr: IQuickAddress) => {
    // console.log('newAddr => ', newAddr)
    // @ts-ignore
    util.navGoBack(this.props)
    const { subscriptionAddressContact } = this.state
    const apiMode = _.isNil(subscriptionAddressContact) ? 'create' : 'update'
    // return
    const reqBody = {
      name: newAddr.name,
      // @ts-ignore
      address1: newAddr.address1,
      address2: newAddr.address2,
      sub_district: newAddr.sub_district,
      district: newAddr.district,
      province: newAddr.province,
      postal_code: newAddr.postal_code,
      telephone: newAddr.telephone,
      legal_entity_type: `${newAddr.legal_entity_type}`,
      legal_entity_id: _.has(newAddr, 'legal_entity_id') && !_.isNil(newAddr.legal_entity_id) ? `${newAddr.legal_entity_id}` : '',
      // branch_number: newAddr.branch_number,
      email: newAddr.email,
    }
    const apiOptions: IApiOptions = {
      showSpinner: true,
    }
    if (apiMode === 'update') {
      // @ts-ignore
      reqBody.address_id = subscriptionAddressContact.id
    }
    if (_.has(newAddr, 'note')) {
      // @ts-ignore
      reqBody.note = newAddr.note
    }
    const res = await api.postV2(`xselly/address/${apiMode}`, reqBody, apiOptions)
    // console.log('res => ', res)
    if (res.id) {
      await util.setStatePromise(this, { subscriptionAddressContact: res, isTaxReceiptRequested: true })
    }
  }

  _navToEditAddressView = async () => {
    // @ts-ignore
    const { navigation } = this.props
    const { subscriptionAddressContact, pendingOrderData } = this.state
    if (!_.isNil(pendingOrderData)) {
      return
    }
    const _onSubmit = async (newAddr: IQuickAddress) => {
      const isSuccess = await this._onSaveQuickAddress(newAddr)
      return { isGoBack: isSuccess }
    }

    const initAddress: any = {}

    if (!_.isNil(subscriptionAddressContact)) {
      initAddress.name = subscriptionAddressContact.name
      initAddress.address1 = subscriptionAddressContact.address1
      initAddress.address2 = subscriptionAddressContact.address2
      initAddress.sub_district = subscriptionAddressContact.sub_district
      initAddress.district = subscriptionAddressContact.district
      initAddress.province = subscriptionAddressContact.province
      initAddress.postal_code = subscriptionAddressContact.postal_code
      initAddress.telephone = subscriptionAddressContact.telephone
      initAddress.legal_entity_type = subscriptionAddressContact.legal_entity_type
      initAddress.legal_entity_id = subscriptionAddressContact.legal_entity_id
      initAddress.email = subscriptionAddressContact.email
      initAddress.note = subscriptionAddressContact.note
      initAddress.id = subscriptionAddressContact.id
      initAddress.disbleAddress2 = true
    }

    const navParams: IAddressFormViewNavParams = {
      initAddress,
      submitButtonText: 'บันทึก',
      headerTitle: 'แก้ไขที่อยู่ใบกํากับภาษี',
      // @ts-ignore
      onSubmit: _onSubmit,
    }

    navigation.dispatch(NavActions.navToAddressFormView(navParams))
  }

  _onSubmitPayment = async () => {
    const {
      addOnPackages,
      selectedMainPackage,
      profile,
      paymentPostDate,
      uploadedUrl,
      subscriptionPackageList,
      mode,
      isTaxReceiptRequested,
      isTaxWithheld,
      subscriptionAddressContact,
      pendingOrderData,
    } = this.state
    // if (_.isNil(resultPayment)) {
    //   p.op.showConfirmationOkOnly('ยอดชำระเงินไม่ถูกต้อง', 'กรุณาติดต่อทีมงาน')
    //   return
    // }
    if (_.isNil(uploadedUrl)) {
      p.op.showConfirmationOkOnly('', 'อัพโหลดหลักฐานการชำระเงินไม่สำเร็จ')
      this._unSetLoading()
      return
    }
    // if (isTaxReceiptRequested && _.isNil(subscriptionAddressContact)) {
    //   p.op.showConfirmationOkOnly('', 'กรุณาระบุที่อยู่ใบกํากับภาษี')
    //   this._unSetLoading()
    //   return
    // }
    // const price = this._getSumTotalPayment()
    // const whTex = this._getSumTotalWhTex()
    // const sumTotalPrice = isTaxWithheld ? price - whTex : price
    const items = _.isNil(addOnPackages) || addOnPackages.length === 0 ? [] : _.cloneDeep(addOnPackages)
    let mainPackage = null
    if (!_.isNil(selectedMainPackage)) {
      mainPackage = {
        sku: selectedMainPackage.sku,
        billing_cycle: selectedMainPackage.billing_cycle,
        qty: 1,
      }
    }
    // console.log('mainPackage => ', mainPackage)
    if (mode !== 'add_on') {
      items.push(mainPackage)
    }

    const paidAt = dayjs(paymentPostDate).format('YYYY-MM-DD HH:mm:ss')
    // console.log('isTaxReceiptRequested //=> ', isTaxReceiptRequested)
    // return
    const reqBody = {
      user_id: profile.user_id,
      paid_at: paidAt,
      img_url: uploadedUrl,
      // is_tax_withheld: isTaxWithheld,
      // is_vat: true,
      // is_tax_receipt_requested: isTaxReceiptRequested,
      // total_amount: pendingOrderData.total_amount,
      // payment_method_id: 1, // DELETE ME LATER
      // purchase_channel_id: 1, // NEW
      // payment: {
      //   paid_at: paidAt,
      //   ref_info: uploadedUrl,
      // },
      // items,
    }

    // if (!_.isNil(subscriptionAddressContact)) {
    //   // @ts-ignore
    //   reqBody.billing_address_id = subscriptionAddressContact.id
    // }
    // console.log('reqBody => ', reqBody)
    const apiOptions: IApiOptions = {
      showSpinner: true,
    }

    const res: IResponseGetSubscriptionsOrder = await api.postV2('xselly/payment/update', reqBody, apiOptions)
    // console.log('res => ', res)
    if (res?.id) {
      // p.op.showConfirmationOkOnly(
      //   'อัพโหลดหลักฐานการชำระเรียบร้อย',
      //   `กรุณารอระบบทำการตรวจสอบหลักฐานการชำระเงินภายใน 30 นาที ระบบจะอัพเดทแพ็กเกจของคุณให้อัตโนมัติเมื่อผ่านการตรวจสอบ`
      // )
      p.op.showToast('อัพโหลดหลักฐานการชำระเรียบร้อย', 'success')
      // console.log('res.status => ', res.status)
      const params = this._getParams()
      const { succeedPaymentCallBack } = params
      if (_.isFunction(succeedPaymentCallBack)) {
        succeedPaymentCallBack(res.status)
      }
      // @ts-ignore
      util.navGoBack(this.props)
      // const mainPackageSku = res.items.find((item) => _.includes(CONS.SUBSCRIPTION_MAIN_PACKAGE_SKU, item.sku))
      // // console.log('mainPackageSku => ', mainPackageSku)
      // const newMainPackage = _.isNil(mainPackageSku)
      //   ? this.state.selectedMainPackage
      //   : subscriptionPackageList.items.find((item) => item.sku === mainPackageSku.sku)

      // const newAddOnPackages = res.items.filter((item) => !_.includes(CONS.SUBSCRIPTION_MAIN_PACKAGE_SKU, item.sku))
      // await util.setStatePromise(this, {
      //   pendingOrderData: res,
      //   selectedMainPackage: newMainPackage,
      //   addOnPackages: newAddOnPackages,
      //   subscriptionAddressContact: _.has(res, 'billing_address') ? res.billing_address : null,
      // })
    }
    this._unSetLoading()
  }

  // ฟังก์ชัน _getMainPackage ใช้สำหรับดึงข้อมูลแพ็กเกจหลัก (Main Package)
  // โดยตรวจสอบจากรายการคำสั่งซื้อที่รอดำเนินการ (pendingOrderData)
  _getMainPackage = () => {
    const { subscriptionPackageList, pendingOrderData } = this.state
    // ถ้าไม่มีข้อมูล pendingOrderData ให้คืนค่า null
    if (!pendingOrderData) return null
    // ค้นหา SKU ของแพ็กเกจหลักจากรายการ items ใน pendingOrderData
    // โดยใช้ค่าคงที่ CONS.SUBSCRIPTION_MAIN_PACKAGE_SKU เพื่อตรวจสอบว่า SKU นั้นเป็นแพ็กเกจหลักหรือไม่
    const mainPackageSku = pendingOrderData.items.find((item) => CONS.SUBSCRIPTION_MAIN_PACKAGE_SKU.includes(item.sku))?.sku
    // ค้นหาและคืนค่าข้อมูลแพ็กเกจหลักจาก subscriptionPackageList โดยใช้ SKU ที่หาได้
    // ถ้าไม่พบข้อมูล ให้คืนค่า null
    return subscriptionPackageList.items.find((item) => item.sku === mainPackageSku) || null
  }

  _getAddonPackage = () => {
    const { pendingOrderData } = this.state
    if (!pendingOrderData) return null

    return pendingOrderData.items
      .filter((item) => !CONS.SUBSCRIPTION_MAIN_PACKAGE_SKU.includes(item.sku))
      .map(({ sku, billing_cycle, qty }) => ({ sku, billing_cycle, qty }))
  }

  _cancelPendingOrder = async () => {
    const { profile, pendingOrderData } = this.state
    const { id } = pendingOrderData
    const isUserConfirmed = await new Promise<boolean>((passConfirm) => {
      p.op.showConfirmation(
        `ยกเลิกคำสั่งซื้อ #${id}`,
        `ต้องการยกเลิกคำสั่งซื้อ #${id} หรือไม่`,
        () => passConfirm(true),
        () => passConfirm(false)
      )
    })
    if (!isUserConfirmed) return
    const reqBody = {
      user_id: profile.user_id,
    }
    const apiOptions: IApiOptions = {
      showSpinner: true,
    }
    const res = await api.postV2('xselly/order/cancel', reqBody, apiOptions)
    // console.log('res cancel => ', res)
    if (res?.id) {
      const params = this._getParams()
      const { cancelPayment } = params
      if (_.isFunction(cancelPayment)) {
        p.op.showToast('ยกเลิกคำสั่งซื้อเรียบร้อย', 'success')
        cancelPayment()
        // @ts-ignore
        util.navGoBack(this.props)
      }
    }
  }

  _getSubscriptionOrder = async () => {
    const reqBody = {
      is_pending: true,
    }
    const apiOptions: IApiOptions = {
      showSpinner: true,
    }
    const res = await api.postV2(api.POST_ORDER_SUBSCRIPTION_GET, reqBody, apiOptions)
    // console.log('res => ', res)
    if (res?.id) {
      if (res.status === 'pending' && res.payment.status === 'unpaid') {
        this.inLoopPamyntChackProcess = false
        // await util.delay(3000)
        // this.inLoopPamyntChackProcess = true
        // await this._loopChackPayment()
      }
    } else {
      // p.op.showConfirmationOkOnly('', 'รายการคำสั่งซื้อเสร็จสิ้นแล้ว')
      this.goBack()
    }
  }

  _requestQrCode = async () => {
    // 977965
    this._setLoading()
    const reqBody = {
      is_pending: true,
    }
    const apiOptions: IApiOptions = {
      showSpinner: true,
    }
    const res = await api.postV2(api.POST_GET_QR_PAYMENT_SUBSCRIPTION, reqBody, apiOptions)
    // console.log('res => ', res)
    if (res?.order_id) {
      await util.setStatePromise(this, {
        qrCodeObject: res,
      })
      this._unSetLoading()
      this.inLoopPamyntChackProcess = true
      await this._loopChackPayment(true)
    }
    this._unSetLoading()
  }

  // isQrLoop = true จะเป็นการวนลูปเช็คการชำระเงินแบบ QR และไม่หยุดจนกว่าจะสำเร็จ
  _loopChackPayment = async (isQrLoop = false) => {
    const { pendingOrderData } = this.state
    if (_.isNil(pendingOrderData)) {
      return
    }
    const reqBody = {
      order_id: pendingOrderData.id,
    }
    const res: IResponseGetSubscriptionsOrder = await api.postV2(api.POST_ORDER_SUBSCRIPTION_GET, reqBody)
    // console.log('_loopChackPayment res // => ', res)
    const { status } = res.payment
    if (!_.isNil(status) && status !== 'unpaid' && !isQrLoop) {
      this.inLoopPamyntChackProcess = false
      return
    }
    if (res?.status === 'completed') {
      this.props.fetchSubscription()
      const params = this._getParams()
      const { succeedPaymentCallBack } = params
      if (_.isFunction(succeedPaymentCallBack)) {
        succeedPaymentCallBack()
      }
      // p.op.showConfirmationOkOnly('', 'ระบบได้ทำการตรวจสอบการชำระเงินเรียบร้อยแล้ว', () => {
      this.goBack()
      // })
      await util.setStatePromise(this, { pendingOrderData: res })
      this.inLoopPamyntChackProcess = false
      return
    }

    if (res?.status === 'cancelled') {
      this.props.fetchSubscription()
      p.op.showConfirmationOkOnly('', 'ระบบได้ปฎิเสธการชำระเงิน', () => {
        this.inLoopPamyntChackProcess = false
        this.goBack()
      })
    }
    // console.log('this.inLoopPamyntChackProcess => ', this.inLoopPamyntChackProcess)
    await util.delay(3000)
    if (this.inLoopPamyntChackProcess) {
      await this._loopChackPayment(isQrLoop)
    }
  }

  componentWillUnmount() {
    this.inLoopPamyntChackProcess = false
  }
}
